import { useState } from "react";

import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";

import TeamMemberForm from "../TeamMemberForm/TeamMemberForm";

import useTeamMemberDropdownMenuOptions from "./hooks/useTeamMemberDropdownMenuOptions";

export default function TeamMemberDropdownMenu({ member, production }) {
	const [open, setOpen] = useState(false);

	const options = useTeamMemberDropdownMenuOptions({ member, production, setOpen });

	return (
		<>
			<DropdownMenu options={options} />

			{open && <TeamMemberForm member={member} production={production} onClose={() => setOpen(false)} />}
		</>
	);
}
